<template>

  <v-container fluid :class="{
    'page-content': true,
    'user-member-table': true,
    'user-member-table-clickable': canViewDetails
  }">

    <v-data-table
        :headers="headers"
        :items="userItems"
        :search="search"
        :options.sync="dataOptions"
        :footer-props="paginationOptions"
        :loading="isDataLoading"
        :server-items-length="totalItems"
        @click:row="goToItemPage">

      <!-- (email) -->
      <template v-slot:[`item.email`]="{ item }">
        <span>{{ item.email }}</span>
      </template>

      <!-- created date -->
      <template v-slot:item.created_at="{ item }">
        <span>{{ formatDateTime(item.created_at) }}</span>
      </template>

      <!-- roles -->
      <template v-slot:item.roles="{ item }">
        <template v-if="item.roles && item.roles.length > 0">
          <v-chip v-for="role in item.roles"
              label
              class="mb-2 mr-2 white--text"
              :color="getRoleChipColor(role)"
              :key="role">
            {{ role }}
          </v-chip>
        </template>
      </template>

      <!-- (status) -->
      <template v-slot:[`item.user_status`]="{ item }">
        <v-chip label outlined :class="item.user_status" v-if="item.user_status">
          {{ item.user_status }}
        </v-chip>
      </template>
    </v-data-table>

  </v-container>

</template>

<script>

export default {
  name: 'UserMemberListDataTable',

  props: {
    canViewDetails: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Last Name', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Roles', sortable: false, value: 'roles' },
        { text: 'Added to System', value: 'created_at' },
        { text: 'Status', value: 'user_status' }
      ],
      isDataLoading: false,
      userData: null,
      dataLoadingError: null,
      paginationOptions: {
        'items-per-page-options': [10, 25, 50, 100]
      },
      dataOptions: {
        itemsPerPage: 10,
        // NOTE - Currently enabled for single field sort only !!!
        sortBy: ['last_name,first_name'],
        sortDesc: [false]
      },
      search: null
    }
  },

  computed: {
    userItems () {
      return (this.userData) ? this.userData.items : []
    },
    dataMeta () {
      return (this.userData) ? this.userData.meta : {}
    },
    totalItems () {
      return this.dataMeta.total_items || 0
    }
  },

  watch: {
    // Observe changes invoked by the data-table component (e.g. pagination, sorting)
    dataOptions: {
      handler () {
        this.queryData()
      },
      deep: true
    }
    // Observe changes to the search field
    // search: function (updated) {
    //   this.queryData()
    // }
  },

  methods: {
    // Display a date/time
    formatDateTime (date) {
      return (date) ? this.$root.utils.format(date, 'YYYY/MM/DD h:mm a') : ''
    },

    getRoleChipColor (role) {
      switch (role) {
        case 'owner': return 'blue'
        case 'admin': return 'amber darken-3'
        case 'dispatcher': return 'orange darken-4'
        case 'driver': return 'blue-grey lighten-1'
        case 'member': return 'blue-grey lighten-1'
        default: return 'grey'
      }
    },

    goToItemPage (item) {
      if (!this.canViewDetails) return false
      if (item && item.model) {
        this.$root.goTo('user-item', { userId: item.id })
      } else {
        console.error('Invalid item data. Cannot invoke item page.')
      }
    },

    // Perform query of users
    async queryData () {
      this.isDataLoading = true

      try {
        // Build sort
        // NOTE - Currently enabled for single field sort only !!!
        let orderBy = null
        const sortBy = this.dataOptions.sortBy
        const sortDesc = this.dataOptions.sortDesc
        if (sortBy && sortBy.length > 0) {
          const isDesc = (sortDesc && sortDesc.length > 0) ? sortDesc[0] : false
          const prefix = (isDesc) ? '-' : ''
          orderBy = `${prefix}${sortBy[0]}`
        }

        // Build pagination
        const page = this.dataOptions.page || 1
        const limit = this.dataOptions.itemsPerPage
        const skip = (page === 1) ? 0 : (page - 1) * limit

        // Build request input
        const params = {
          skip,
          limit
        }

        // Apply sorting
        if (orderBy) params.order_by = orderBy

        // console.log('[DEVING] query data:', this.dataOptions, params)

        // Retrieve results
        this.userData = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: 'users',
          opts: { params }
        })
      } catch (err) {
        console.error(err)
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style>
  .user-member-table-clickable .theme--dark.v-data-table {
    cursor: pointer;
  }

  .user-member-table .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .user-member-table .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .user-member-table .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 65px;
  }
</style>
